module.exports = __webpack_public_path__ + "static/img/12.9331ad9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/12.jpeg
// module id = //zb
// module chunks = 4